import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postData,
  getData,
  putData,
  patchData,
} from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { setShowError } from "../../Common/Alerts/alertsSlice";

export const createJobPosting = createAsyncThunk(
  "jobPosting/createJobPosting",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const response = await postData("/jobs/create", data);
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const fetchJobPostings = createAsyncThunk(
  "jobPosting/fetchJobPostings",
  async (queryParams, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const response = await getData("/jobs/getall", queryParams);
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const fetchSingleJobPosting = createAsyncThunk(
  "jobPosting/fetchSingleJobPosting",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const response = await getData(`/jobs/getbyid/${id}`);
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const updateJobPosting = createAsyncThunk(
  "jobPosting/updateJobPosting",
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const response = await putData(`/jobs/update/${id}`, data);
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const changeJobPostingStatus = createAsyncThunk(
  "jobPosting/changeJobPostingStatus",
  async ({ id, status }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const response = await patchData(`/jobs/update-status/${id}`, {
        status,
      });
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const deleteJobPosting = createAsyncThunk(
  "jobPosting/deleteJobPosting",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const response = await patchData(`/jobs/delete/${id}`);
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);
